<template>
  <section>
    <WCFormGroup>
      <WCLabel for="coupon">
        <b>{{ $t('haveCoupons') }}</b>
      </WCLabel>
      <WCInputGroup class="mb-2">
        <WCInput v-model="form.coupon" id="coupon" placeholder="Coupon code" />
        <template v-slot:right>
          <button
            @click="$emit('addcoupon', form.coupon)"
            class="btn btn-primary"
            type="button"
            :disabled="form.coupon.length === 0"
          >
            {{ $t('apply') }}
          </button>
        </template>
      </WCInputGroup>
    </WCFormGroup>

    <p v-if="!addedCouponValid" class="text-danger font-size-sm">
      {{ $t('sorryCouponCode') }}
    </p>

    <template v-if="coupons">
      <div v-for="coupon in coupons" :key="coupon.id" data-section="appliedCoupons">
        <div class="d-flex justify-content-between align-items-center">
          <strong>{{ coupon.code }}</strong>
          <button
            class="btn btn-link underline-link-from-center m-0 p-0"
            @click="$emit('removecoupon', coupon.code)"
          >
            {{ $t('remove') }}
          </button>
        </div>
        <span>{{ coupon.name }}</span>
      </div>
    </template>
  </section>
</template>

<script>
import WCFormGroup from '@/modules/forms/components/WCFormGroup/WCFormGroup.vue';
import WCInput from '@/modules/forms/components/WCInput/WCInput.vue';
import WCInputGroup from '@/modules/forms/components/WCInputGroup/WCInputGroup.vue';
import WCLabel from '@/modules/forms/components/WCLabel/WCLabel.vue';

export default {
  name: 'WCCoupons',
  components: { WCFormGroup, WCInput, WCInputGroup, WCLabel },
  props: {
    coupons: {
      type: Array,
    },
    addedCouponValid: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      form: {
        coupon: '',
      },
    };
  },
};
</script>

<style lang="scss" scoped></style>
